import { render } from "./pagenotfound.vue?vue&type=template&id=48dabaad"
import script from "./pagenotfound.js?vue&type=script&lang=js&external"
export * from "./pagenotfound.js?vue&type=script&lang=js&external"

import "./pagenotfound.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__